import disable from "@/api/disable";

export default () => {
  disable(false);
};
